import { useTranslation } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative py-20 overflow-hidden bg-[#0A0A0B]" data-testid="footer">
      <div className="h-px mb-16" style={{ background: "linear-gradient(to right, transparent, #2A2A2E, transparent)" }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <a href="#" className="flex items-center">
              <img
                src="/fwdco-logo.png"
                alt="FWDCO Group"
                className="h-16 w-auto"
                style={{ filter: "invert(1) hue-rotate(180deg)" }}
                draggable="false"
              />
            </a>
            <p
              className="mt-4"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 400,
                fontSize: "18px",
                color: "#B8B8C0",
              }}
            >
              {t.footer.tagline}
            </p>
          </div>

          <nav className="flex flex-wrap gap-6 md:gap-8">
            {t.footer.links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="hover:text-[#C9A96E] transition-colors"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 400,
                  fontSize: "18px",
                  color: "#B8B8C0",
                }}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "18px",
              color: "#B8B8C0",
            }}
          >
            {t.footer.copyright(currentYear)}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-center pointer-events-none select-none">
        <span
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontWeight: 500,
            fontSize: "clamp(80px, 18vw, 280px)",
            lineHeight: 0.8,
            color: "#F5F1E8",
            opacity: 0.02,
          }}
        >
          FWDCO
        </span>
      </div>
    </footer>
  );
}
